import React from 'react';
import { AlertCircle } from 'react-feather';
import classNames from 'classnames';
import { Icon } from 'ui';

const getAttendanceText = status => {
  const translations = {
    did_attend: t('in_person_training.attendance.phrase.did_attend'),
    did_not_attend: t('in_person_training.attendance.phrase.did_not_attend'),
    limit_met: t('in_person_training.attendance.phrase.limit_met'),
    will_attend: t('in_person_training.attendance.phrase.will_attend'),
    will_not_attend: t('in_person_training.attendance.phrase.will_not_attend'),
  };
  return translations[status];
};

const getIconName = (informative, affirmative) => {
  if (informative) return 'info';
  return affirmative ? 'correct' : 'remove';
};

const AttendanceStatus = ({ status }) => {
  const affirmative = ['did_attend', 'will_attend'].includes(status);
  const negative = ['did_not_attend', 'will_not_attend'].includes(status);
  const informative = ['limit_met'].includes(status);

  const iconName = getIconName(informative, affirmative);
  const className = classNames(
    'p-2-8 bdrs-small fz-sm fw-b f-smooth d-f ai-c',
    affirmative && 'bg-success-dark c-white',
    negative && 'border border-midnight-60 c-midnight-100',
    informative && 'SelectableSession-capacity',
    !informative && 'd-ib',
  );

  return (
    <div className={className}>
      {informative && (
        <AlertCircle size={15} className="SelectableSession-icon" />
      )}
      {!informative && <Icon name={iconName} className="mr-4" />}
      {getAttendanceText(status)}
    </div>
  );
};

export default AttendanceStatus;
